// Common US car makes and their popular models. Used by the Add Vehicle form
// for autocomplete. Users can still type a custom value if their vehicle
// isn't listed (rare makes, kit cars, JDM imports). Update when new mainstream
// models appear; not meant to be exhaustive.

export const VEHICLE_MAKES_MODELS = {
  Acura: ['ILX', 'Integra', 'MDX', 'RDX', 'TLX'],
  'Alfa Romeo': ['Giulia', 'Stelvio', 'Tonale'],
  'Aston Martin': ['DB11', 'DBX', 'Vantage'],
  Audi: ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q3', 'Q5', 'Q7', 'Q8', 'e-tron'],
  BMW: [
    '2 Series',
    '3 Series',
    '4 Series',
    '5 Series',
    '7 Series',
    'X1',
    'X3',
    'X5',
    'X7',
    'i4',
    'iX',
  ],
  Bentley: ['Bentayga', 'Continental GT', 'Flying Spur'],
  Buick: ['Enclave', 'Encore', 'Envision'],
  Cadillac: ['CT4', 'CT5', 'Escalade', 'LYRIQ', 'XT4', 'XT5', 'XT6'],
  Chevrolet: [
    'Blazer',
    'Bolt EV',
    'Camaro',
    'Colorado',
    'Corvette',
    'Equinox',
    'Malibu',
    'Silverado 1500',
    'Suburban',
    'Tahoe',
    'Traverse',
    'Trax',
  ],
  Chrysler: ['300', 'Pacifica'],
  Dodge: ['Challenger', 'Charger', 'Durango'],
  Ferrari: ['296', 'F8', 'Purosangue', 'Roma', 'SF90'],
  Fiat: ['500', '500X'],
  Ford: [
    'Bronco',
    'Bronco Sport',
    'Edge',
    'Escape',
    'Expedition',
    'Explorer',
    'F-150',
    'F-250',
    'F-350',
    'Maverick',
    'Mustang',
    'Mustang Mach-E',
    'Ranger',
  ],
  GMC: ['Acadia', 'Canyon', 'Sierra 1500', 'Terrain', 'Yukon'],
  Genesis: ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  Honda: [
    'Accord',
    'Civic',
    'CR-V',
    'HR-V',
    'Odyssey',
    'Passport',
    'Pilot',
    'Ridgeline',
  ],
  Hyundai: [
    'Elantra',
    'IONIQ 5',
    'IONIQ 6',
    'Kona',
    'Palisade',
    'Santa Cruz',
    'Santa Fe',
    'Sonata',
    'Tucson',
    'Venue',
  ],
  Infiniti: ['Q50', 'QX50', 'QX55', 'QX60', 'QX80'],
  Jaguar: ['E-PACE', 'F-PACE', 'F-TYPE', 'I-PACE', 'XF'],
  Jeep: [
    'Cherokee',
    'Compass',
    'Gladiator',
    'Grand Cherokee',
    'Renegade',
    'Wagoneer',
    'Wrangler',
  ],
  Kia: [
    'Carnival',
    'EV6',
    'EV9',
    'Forte',
    'K5',
    'Niro',
    'Seltos',
    'Sorento',
    'Soul',
    'Sportage',
    'Telluride',
  ],
  'Land Rover': [
    'Defender',
    'Discovery',
    'Discovery Sport',
    'Range Rover',
    'Range Rover Evoque',
    'Range Rover Sport',
    'Range Rover Velar',
  ],
  Lexus: ['ES', 'GX', 'IS', 'LS', 'LX', 'NX', 'RX', 'RZ', 'UX'],
  Lincoln: ['Aviator', 'Corsair', 'Nautilus', 'Navigator'],
  Lucid: ['Air', 'Gravity'],
  Maserati: ['Ghibli', 'Grecale', 'Levante', 'MC20'],
  Mazda: ['CX-30', 'CX-5', 'CX-50', 'CX-9', 'CX-90', 'Mazda3', 'MX-5 Miata'],
  'Mercedes-Benz': [
    'A-Class',
    'C-Class',
    'CLA',
    'CLS',
    'E-Class',
    'EQB',
    'EQE',
    'EQS',
    'G-Class',
    'GLA',
    'GLB',
    'GLC',
    'GLE',
    'GLS',
    'S-Class',
  ],
  Mini: ['Clubman', 'Convertible', 'Cooper', 'Countryman'],
  Mitsubishi: ['Eclipse Cross', 'Mirage', 'Outlander', 'Outlander Sport'],
  Nissan: [
    'Altima',
    'Ariya',
    'Armada',
    'Frontier',
    'Kicks',
    'LEAF',
    'Maxima',
    'Murano',
    'Pathfinder',
    'Rogue',
    'Sentra',
    'Titan',
    'Versa',
  ],
  Polestar: ['Polestar 2', 'Polestar 3', 'Polestar 4'],
  Porsche: ['718 Cayman', '911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  Ram: ['1500', '2500', '3500', 'ProMaster'],
  'Rolls-Royce': ['Cullinan', 'Ghost', 'Phantom', 'Spectre'],
  Rivian: ['R1S', 'R1T'],
  Subaru: [
    'Ascent',
    'BRZ',
    'Crosstrek',
    'Forester',
    'Impreza',
    'Legacy',
    'Outback',
    'Solterra',
    'WRX',
  ],
  Tesla: ['Cybertruck', 'Model 3', 'Model S', 'Model X', 'Model Y'],
  Toyota: [
    '4Runner',
    '86',
    'Avalon',
    'bZ4X',
    'C-HR',
    'Camry',
    'Corolla',
    'Corolla Cross',
    'Crown',
    'GR86',
    'GR Corolla',
    'GR Supra',
    'Highlander',
    'Land Cruiser',
    'Mirai',
    'Prius',
    'RAV4',
    'Sequoia',
    'Sienna',
    'Tacoma',
    'Tundra',
    'Venza',
  ],
  Volkswagen: [
    'Arteon',
    'Atlas',
    'Atlas Cross Sport',
    'Golf',
    'GTI',
    'ID.4',
    'Jetta',
    'Passat',
    'Taos',
    'Tiguan',
  ],
  Volvo: [
    'C40',
    'EX30',
    'EX90',
    'S60',
    'S90',
    'V60',
    'V90',
    'XC40',
    'XC60',
    'XC90',
  ],
};

export const VEHICLE_MAKES = Object.keys(VEHICLE_MAKES_MODELS).sort();
